import { render } from "./flag.vue?vue&type=template&id=16c67cad&scoped=true"
import script from "./flag.vue?vue&type=script&lang=js"
export * from "./flag.vue?vue&type=script&lang=js"

import "./flag.vue?vue&type=style&index=0&id=16c67cad&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16c67cad"]])

export default __exports__